import { axiosGet, axiosPost } from '../axios/config';

export const getAboutContent = (data) => {
  return axiosGet('/app-content/about', data);
};

export const addAboutContent = (data) => {
  return axiosPost('/app-content/add-about', data);
};
